<template>
  <status-indicator
    :label="isInactive ? $t('base.inactive') : $t('base.active')"
    :color="isInactive ? INACTIVE_COLORS.background : ACTIVE_COLORS.background"
    :border-color="isInactive ? INACTIVE_COLORS.text : ACTIVE_COLORS.text"
  />
</template>

<script>
import StatusIndicator from '@/global/components/table/components/StatusIndicator.vue'

// The colours the old active/inactive pill used, kept as-is - only the shape
// they are painted on changed.
const ACTIVE_COLORS = {
  text: '#65AD45',
  background: '#ECFCCB'
}
const INACTIVE_COLORS = {
  text: '#EF4444',
  background: '#FEE2E2'
}

export default {
  name: 'ActiveIcon',

  components: {
    StatusIndicator
  },

  props: {
    // Holds the deactivation timestamp, so any value at all means "inactive".
    // `0` is treated the same way, matching the previous behaviour.
    cellData: {
      type: [String, Number],
      default: ''
    }
  },

  data () {
    return {
      ACTIVE_COLORS,
      INACTIVE_COLORS
    }
  },

  computed: {
    isInactive () {
      return (!!this.cellData && typeof this.cellData === 'string') || this.cellData === 0
    }
  }
}
</script>
